import { gsap } from "gsap";

window.popupClose = function(id, validity, event) {
    if (validity === "session") {
        document.cookie = "closed_popup__" + id + "=" + id + "; path=/";
    } else if (validity === "permanent") {
        document.cookie = "closed_popup__" + id + "=" + id + "; max-age=1451520000; path=/";
    } else {
        document.cookie = "closed_popup__" + id + "=" + id + "; max-age=" + validity + "; path=/";
    }

    let popupNode = event.target.closest(".c-popup");

    gsap.to(popupNode, {autoAlpha: 0, duration: 0.3, delay: 0.1, onComplete: function(){
        popupNode.hidden = true;
        popUpNode.removeAttribute('style');
    }});
}